import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../../lib/cn";

type ProjectMediaPanelProps = {
  className?: string;
  label?: ReactNode;
  nav?: ReactNode;
} & Pick<HTMLAttributes<HTMLDivElement>, "onPointerDown" | "onPointerMove" | "onPointerUp" | "onPointerCancel">;

export function ProjectMediaPanel({
  className,
  label,
  nav,
  onPointerCancel,
  onPointerDown,
  onPointerMove,
  onPointerUp
}: ProjectMediaPanelProps) {
  return (
    <div
      className={cn("projects-mediaPanel", className)}
      data-project-animate="media"
      onPointerCancel={onPointerCancel}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
    >
      {label ? <div className="projects-mediaPanel__label">{label}</div> : null}
      {nav ? (
        <div className="projects-mediaPanel__nav" data-carousel-control="true">
          {nav}
        </div>
      ) : null}
    </div>
  );
}
